import {
    ChangeDetectionStrategy,
    Component, ElementRef,
    HostListener, Inject,
    Input,
    OnChanges,
    OnInit, Renderer2,
    SimpleChanges, ViewChild
} from '@angular/core';
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { DescriptionType, RuleForFareNoteType } from "@afidium/ts-facade";
import { DOCUMENT } from "@angular/common";

@Component({
    selector: 'fare-note',
    template: `
        <div class="titles"
             #titles
             [class.is-sticky]="isSticky">
            <div class="title"
                 *ngFor="let note of notes; let i = index"
                 (click)="show(i)"
                 [class.selected]="shownIndex === i">
                {{note.title}}
                <i class="fa"
                   [class.fa-angle-right]="shownIndex !== i"
                   [class.fa-angle-left]="shownIndex === i"></i>
            </div>
        </div>
        <div class="placeholder" #placeholder [class.is-active]="isSticky" [ngStyle]="{'width':width, 'height': height}"></div>
        <div class="body">
            <ng-container *ngIf="shownIndex || shownIndex === 0">
                <div class="title">
                    {{notes[shownIndex].title}}
                </div>
                <div class="line" *ngFor="let line of notes[shownIndex].textLineArray">
                    {{line}}
                </div>
                <div class="line" *ngIf="!notes[shownIndex].textLineArray?.length">
                    {{wording.noText}}
                </div>
            </ng-container>
        </div>
    `,
    styleUrls: ['./fare-note-rules.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FareNoteRulesComponent implements OnChanges {

    @Input()
    public ruleArray: [RuleForFareNoteType, ...RuleForFareNoteType[]];

    public notes: DescriptionType[];

    public shownIndex: number;

    public wording: ILabels = {
        noText: Yii.t('wui-shared-js', 'Aucun contenu')
    };

    // placeholder dimensions
    public width: string = "0";
    public height: string = "0";

    public isSticky: boolean;
    @ViewChild('placeholder')
    private readonly placeholder: ElementRef;
    @ViewChild('titles')
    private readonly titles: ElementRef;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2,
        @Inject(DOCUMENT) private readonly document: Document
    ) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.ruleArray && changes.ruleArray.currentValue) {
            this.notes = this.ruleArray.reduce(
                (notes: DescriptionType[], rule: RuleForFareNoteType) => {
                    return [
                        ...notes,
                        ...rule.descriptionArray
                    ];
                },
                []

            );
        }

    }

    public show(index: number): void {
        this.shownIndex = index === this.shownIndex ? null : index;
    }

    // sticky system, test with CC
    @HostListener('window:scroll', [])
    public onWindowScroll(): void {
        const containerTopPosition: number = this.elementRef.nativeElement.getBoundingClientRect().top;
        const containerBottomPosition: number = this.elementRef.nativeElement.getBoundingClientRect().bottom;
        if (containerTopPosition < 15) {
            if (!this.isSticky) {
                this.isSticky = true;
                this.width = `${this.titles.nativeElement.offsetWidth}px`;
                this.height = `${this.titles.nativeElement.offsetHeight}px`;
            }
        } else {
            if (this.isSticky) {
                this.isSticky = false;
                this.width = "0";
                this.height = "0";
            }
        }
        if(this.isSticky && containerBottomPosition < (this.titles.nativeElement.offsetHeight + 15)){
            this.isSticky = false;
            this.width = "0px";
            this.height = "0px";
        }
    }
}

